<template>
  <Divider class="ts-divider" v-bind="$attrs" v-on="$listeners"><slot></slot></Divider>
</template>

<style lang="scss" scoped>
.ts-divider::v-deep {
  &.el-divider {
    background-color: #dbe2ea;
  }

  .el-divider__text {
    background-color: transparent;

    font-family: Roboto;
    font-size: 12px;
    text-align: center;
    color: #9aa5b7;
  }
}
</style>

<script>
import { Divider } from 'element-ui';

export default {
  name: 'TsDivider',
  components: {
    Divider
  }
};
</script>
